import dayjs from "dayjs";

import parseTwtxt from "./parseTwtxt.js";
import type { Twtxt } from "./types.ts";

export default async function loadAndParseTwtxtFile(url = ""): Promise<Twtxt> {
	if (!url) throw new Error("URL is required");

	try {
		const response = await fetch(url);
		const twtxtFile = await response.text();
		const lastModified = dayjs(
			response.headers.get("Last-Modified"),
		).toISOString();

		return {
			...parseTwtxt(twtxtFile),
			lastModified,
		};
	} catch (err) {
		console.error(err);
		throw err;
	}
}
